import React from 'react';
import { motion } from 'framer-motion';

const belongingData = [
    {
        id: 1,
        title: "Global accommodation support ",
        description: "Global accommodation support helps you find safe, comfortable places to stay anywhere in the world. We make housing easy, flexible, and stress-free, with trusted options and support whenever you need it."
    },
    {
        id: 2,
        title: "Inclusive dress code",
        description: "Our inclusive dress code lets everyone feel comfortable and confident while being professional. It respects different cultures, styles, and identities, creating a welcoming workplace where people can truly be themselves."
    },
    {
        id: 3,
        title: "Supportive spaces",
        description: "Supportive spaces are warm, welcoming environments where people feel comfortable, heard, and encouraged. They bring teams together, spark collaboration, and help everyone feel confident, valued, and at ease while working. "
    }
];

const DesignedForBelongingSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-[32px] md:gap-[50px] lg:gap-[100px] px-[20px] md:px-[40px] lg:px-[80px]">
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        variants={{
                            lg: { initial: { opacity: 0, x: -30, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                        }}
                        className="flex flex-col lg:max-w-[500px] lg:sticky lg:top-[120px] h-fit"
                    >
                        <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] leading-[1.2] mb-[16px] md:mb-[24px] tracking-tight">
                            Designed for belonging, built for innovation
                        </h2>
                        <div className="flex flex-col gap-[16px] md:gap-[20px]">
                            <p className="text-[14px] md:text-[16px] font-graphik font-[500] text-[#49577A] leading-[1.6]">
                                Our offices are built for people, not just work. They’re welcoming spaces where you can connect with others, think freely, and feel comfortable throughout your day. Whether you need focus time in a quiet corner, collaboration in open areas, or a quick catch-up in a meeting room, you can work in the way that suits you best.
                            </p>
                            <p className="text-[14px] md:text-[16px] font-graphik font-[500] text-[#49577A] leading-[1.6]">
                                We also care deeply about making every space more accessible, inclusive, and sustainable, working closely with our partners and teams to keep improving how we work together.
                            </p>
                        </div>
                    </motion.div>
                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        className="flex flex-col gap-[16px] md:gap-[24px] lg:gap-[30px]"
                    >
                        {belongingData.map((card) => (
                            <motion.div
                                key={card.id}
                                variants={fadeUpVariant}
                                className="group relative bg-white border border-[#E4E8F5] p-[24px] sm:p-[30px] md:p-[40px] shadow-sm hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-all duration-300 overflow-hidden cursor-default md:hover:-translate-y-1 rounded-sm"
                            >
                                <h3 className="text-[16px] md:text-[20px] font-[600] font-sora text-[#01386A] mb-[12px] md:mb-[20px]">
                                    {card.title}
                                </h3>

                                <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.6] relative z-10">
                                    {card.description}
                                </p>
                                <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-0"></div>
                                <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#F97316] transition-all duration-500 ease-out group-hover:w-full z-10"></div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default DesignedForBelongingSection;